import React, { useEffect, useState } from "react"
import Accordion from "@mui/material/Accordion"
import AccordionSummary from "@mui/material/AccordionSummary"
import AccordionDetails from "@mui/material/AccordionDetails"
import ExpandMoreIcon from "@mui/icons-material/ExpandMore"
import { styled } from "@mui/material/styles"
import NursingDetail from "./NursingDetail"
import { getPastAppointmentNotes } from "core/services/api"
import moment from "moment"
import LockOpenIcon from '@mui/icons-material/LockOpen'
import LockIcon from '@mui/icons-material/Lock'
import NursingDetailWS from "./NursingDetailWS"

const CustomAccordion = styled(Accordion)(({ }) => ({
  backgroundColor: "#AFC4FF",
  margin: "20px",
  borderRadius: "8px",
}))

// @ts-ignore
function PastNotes({ patientInfo, appointmentId, allOrder, smartSummaryData, readOnly, center }: any) {

  const [pastOrders, setpastOrders] = useState<any>()
  useEffect(() => {
    getPastAppointmentNotes(patientInfo?.id, "SUBMITTED").then((res) => {
      setpastOrders(res)
    }).catch((err: any) => {
      console.log(err)
    })
  }, [])
  return (
    <div className="completed-chemo">
      {pastOrders?.map((values: any) => {
        return (
          <CustomAccordion
            key={values?.id}
            square={false}
            sx={{
              "&:before": {
                display: "none",
              },
              "&:after": {
                display: "none",
              },
            }}
          >

            <AccordionSummary
              expandIcon={<ExpandMoreIcon />}
              aria-controls="panel1a-content"
              id="panel1a-header"
            >
              <div className="accordian-heading">
                <div className="accordian-child">Past Appointment Notes</div>

                <div className="accordian-child">
                  {values?.appointmentDate === null ? <>-</> : <>
                    {moment(values?.appointmentDate).format("DD-MM-YYYY")}
                  </>}
                </div>
                <div className="accordian-child">{values?.completedByName}</div>

              </div>
            </AccordionSummary>
            <AccordionDetails
              sx={{
                backgroundColor: "#f7f8fa",
                border: "1px solid #d4d8eb",
              }}
            >
              <div className="nurseEdit" style={{
                display: 'flex',
                justifyContent: 'flex-end',

              }}>
                {console.log(values?.isEditable, "is Editable")}
                {values.isEditable ? <><span><LockOpenIcon /></span></> : <span><LockIcon /></span>
                }
              </div>
              {
                (center && center?.isWondersoftEnabled) ?
                  <NursingDetailWS
                    allOrder={values}
                    patientInfo={patientInfo}
                    appointmentId={appointmentId}
                    isEdit={false}
                    pastNotes={true}
                    smartSummaryData={smartSummaryData}
                    readOnly={true || readOnly}
                  /> :
                  <NursingDetail
                    allOrder={values}
                    patientInfo={patientInfo}
                    appointmentId={appointmentId}
                    isEdit={false}
                    pastNotes="true"
                    smartSummaryData={smartSummaryData}
                    readOnly={true || readOnly}
                  />
              }
            </AccordionDetails>
          </CustomAccordion>
        )
      })}
    </div>
  )
}

export default PastNotes
